module.exports = __webpack_public_path__ + "img/5.c864cfd1.png";